import React from 'react'
import UIInput from './../Input/UIInput.component'

const UITextarea = ({
  className,
  disabled,
  id,
  name,
  label,
  size,
  type,
  getValue,
  onBlur,
  onFocus,
  onChange,
  onValidityChange,
  required,
  hint,
  value,
  onKeyDown,
  onKeyPress,
  rules,
  showValidity,
  autoComplete,
}) => {
  const inputProps = {
    className,
    disabled,
    id,
    name,
    label,
    size,
    type,
    getValue,
    onBlur,
    onFocus,
    onChange,
    required,
    hint,
    value,
    onKeyDown,
    onKeyPress,
    showValidity,
    autoComplete,
  }

  return <UIInput {...inputProps} type='textarea' />
}

export default UITextarea
